import Icon, { IconType } from "@edaz/edazkit/Icon";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import AdHocReportsProcessedViewModel from "viewModels/timeCharges/reporting/adHocReports/adHocReportsProcessedViewModel";

const AdHocReportsProcessedView: ViewComponent<AdHocReportsProcessedViewModel> = observer(({ vm }) => {
  return (
    <Modal
      centered={true}
      show={vm.isOpened}
      onHide={vm.cancel}
      onEscapeKeyDown={vm.cancel}
      dialogClassName="modal-ms confirm-dialog"
      backdropClassName="confirm-dialog-backdrop">
      <Modal.Body className="justify-content-center text-center">
        <div className="col align-items-center">
          <div className="row d-flex justify-content-center mb-4">
            <Icon icon={IconType.ProcessingClock} width={64} height={64} />
          </div>
          <div className="row d-flex justify-content-center mb-3">
            <Modal.Title as="h3" className="mb-1">
              {vm.translate("title")}
            </Modal.Title>
          </div>
          <div className="row d-flex justify-content-center">{vm.translate("text")}</div>
        </div>
      </Modal.Body>
      <Modal.Footer className="col flex-column">
        <div className="col w-90 d-flex justify-content-center mb-4">
          <Button className="w-60" onClick={vm.confirm} variant="primary">
            {vm.translate("confirm")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
});

export default registerView(AdHocReportsProcessedView, AdHocReportsProcessedViewModel);
